/**
 * Component for rendering fillSl1Form tool output.
 *
 * Output is intentionally not rendered here: any generated files are surfaced by the
 * message-level hoist in `preview-message.tsx` so they don't get buried inside the
 * collapsed "How Nova got here" chain-of-thought block when reasoning is enabled.
 * The renderer is kept registered so the wrapper can still render the pending state.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function FillSl1FormTool(_props: { part: unknown; messageUuid: string }) {
  return null;
}
